<template>
	<div>
		<div style="background:#00A6E5;display: flex;justify-content: center;">
			<div style="height: 80px;width: 60%;display: flex;align-items: center;justify-content: space-between;">
				<div style="display: flex;align-items: center;">
					<span style="font-size: 28px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;line-height: 40px;margin-left: 14px;">历史记录</span>
				</div>
				<div @click="goBack" style="width: 80px;height: 36px;border-radius: 4px;border: 1px solid #FFFFFF;display: flex;align-items: center;justify-content: space-around;cursor: pointer;">
					<span style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 22px;
				">返回</span>
				</div>
			</div>
		</div>
		<div style="display: flex;justify-content: center;">
			<div style="width: 60%;">
				<div style="background: #FFFFFF;box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);border-radius: 4px;margin-top: 30px;padding: 20px 30px 20px 30px;margin-bottom: 30px;">
					<div>
						<table border="1" class="table_all">
						<tr>
						<th>类型</th>
						<th>手数</th>
						<th>品种</th>
						<th>开仓时间</th>
						<th>开仓价格</th>
						<th>平仓时间</th>
						<th>平仓价格</th>
						<th>利润</th>
						</tr>
						<tr  v-for="item in list">
							<td>{{item.type}}</td>
							<td>{{item.volumeopen}}</td>
							<td>{{item.symbol}}</td>
							<td>{{item.timeopen}}</td>
							<td>{{item.priceopen}}</td>
							<td>{{item.timeclose}}</td>
							<td>{{item.priceclose}}</td>
							<td>{{item.profit}}</td>
						</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
		<v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
	</div>
</template>
<script>
	import {
		HOST
	} from '../Api.js'
	import pagination from './pagination.vue'
	export default {
		name: 'History',
		props: {
			msg: String
		},
		components: {
			'v-pagination': pagination,
		},
		data() {
			return {
				total: 10,     // 记录总条数
				display: 10,   // 每页显示条数
				current: 1,
				list:[]
			}
		},
		mounted() {
			if(this.$route.params.id){
				localStorage.setItem('HTID',this.$route.params.id);
				this.id = this.$route.params.id;
			}else{
				this.id = localStorage.getItem('HTID');
			}
			this.loadData();
		},
		methods: {
			goBack() {
				this.$router.go(-1)
			},
			loadData() {
				this.$layer.loading({content:'加载中'});
				fetch(HOST+'biggun/history/'+this.id,{
					method: 'POST',
					headers: {
						'content-type': 'application/json'
					},
					body:JSON.stringify({
						page:this.current,
						limit:10
					})
				}).then(response=>response.json()).then(res=>{
				this.$layer.closeAll();
					if(res.code==0){
						this.total = res.count;
						this.list = res.data;
					}
				})
			},
			pagechange:function(currentPage){
			       console.log(currentPage);//该参数就是当前点击的页码数
				   this.current = currentPage;
				   this.loadData();
			       // ajax请求, 向后台发送 currentPage, 来获取对应的数据
			}
		}
	}
</script>

<style scoped>
	.top_block {
		height: 200px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
		border-radius: 4px;
		margin-top: 30px;
	}

	.img_left_block {
		display: flex;
		align-items: center;
	}

	.top_top {
		display: flex;
		justify-content: space-between;
		padding: 20px 30px 40px 30px;
	}

	.tips_item {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.tips_str {
		font-size: 13px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
		line-height: 18px;
	}

	.tips_val {
		font-size: 16px;
		font-family: Helvetica;
		color: #333333;
		line-height: 19px;
		margin-top: 6px;
	}

	.title_bar {
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 25px;
	}
	.table_all{
		width: 100%;
		border: 1px solid #EDEFF1;
		border-collapse:collapse;  
		border-spacing:0px;
		margin-top: 20px;
	}
	.table_all th{
		background: #F1F5F7;
		border: 1px solid #EDEFF1;
		text-align: center;
		height: 48px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;

	}
	.table_all td{
		background: #FFFFFF;
		border: 1px solid #EDEFF1;
		text-align: center;
		height: 54px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;
	}
</style>
